<template>
    <div></div>
</template>
<script setup lang="ts">
definePage({
    meta: {
        layout: 'bare',
    },
});
const auth = useAuth();
auth.logout();
</script>
